module.exports = __webpack_public_path__ + "img/router.bb58d5a.png";